import { Row, Col, Typography } from "antd";

import ForgottenPasswordForm from "components/forms/ForgottenPassword";

const ForgottenPassword = () => {
  return (
    <div
      className="container guttered"
      style={{ maxWidth: "600px", margin: "40px auto" }}
    >
      <Row gutter={[20, 16]}>
        <Col xs={24}>
          <Typography.Title level={2}>Zabudnué heslo</Typography.Title>
          <Typography.Text>
            Zabudli ste heslo? Zadajte email, ktorý používate k vašemu účtu, a
            my vám pomôžeme obnoviť vaše heslo.
          </Typography.Text>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <ForgottenPasswordForm />
        </Col>
      </Row>
    </div>
  );
};

export default ForgottenPassword;
